import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Coloca o conteúdo de impressão como filho direto do <body>. Assim, na hora de
 * imprimir, todo o resto da tela pode ser removido do fluxo (display:none) e o
 * relatório não gera páginas em branco.
 */
export function PrintPortal({ children }: { children: ReactNode }) {
  const [alvo, setAlvo] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const el = document.createElement("div");
    el.className = "print-root";
    document.body.appendChild(el);
    setAlvo(el);
    return () => {
      el.remove();
    };
  }, []);

  if (!alvo) return null;
  return createPortal(children, alvo);
}
